import { axiosInstance as axios } from "services";

export const retryPayment = async (companyId) => {
  const { data } = await axios.post(`/admin/subscription/company/${companyId}/retry-payment`, {});
  if (!data.success) throw new Error(data.error?.message || "Failed to retry payment");
  return data;
};

export const resendInvoice = async (companyId, invoiceId) => {
  const { data } = await axios.post(
    `/admin/subscription/company/${companyId}/resend-invoice`,
    { invoiceId }
  );
  if (!data.success) throw new Error(data.error?.message || "Failed to resend invoice");
  return data;
};

export const refundPayment = async (companyId, { paymentIntentId, amount, reason }) => {
  const { data } = await axios.post(`/admin/subscription/company/${companyId}/refund`, {
    paymentIntentId,
    amount,
    reason,
  });
  if (!data.success) throw new Error(data.error?.message || "Failed to refund payment");
  return data;
};
